import { ISessionGroup } from "lib/types";
import { capitalizeFirstLetter } from "lib/util";

export const getFormattedGroupName = (group?: ISessionGroup): string => {
  if (!group) {
    return "";
  }

  return `${capitalizeFirstLetter(
    group.adjective || ""
  )} ${capitalizeFirstLetter(group?.noun || "")}`;
};
